import { useDispatch } from "react-redux";
import { PROGRESS } from "../../services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Container, Box } from "@mui/material";
import Form from "./TaskForm";

export default function ProgressView() {
  let dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { project, progress } = location.state || {};
  const [defV, setDefV] = React.useState(progress);


  return (
    <>
      <Container>
        <Box sx={{ p: 2 }}>
          <Form
            defaultValues={defV}
            title={`Project started at ${project?.start_project_date.split("T")[0]}`}
            project={project}
            onSubmit={(data) => {
              data.worksite = progress?.worksite
              let ACTION = data.id ? `${PROGRESS}_PATCH` : `${PROGRESS}_POST`;
              dispatch({ type: ACTION, payload: data });
            }}
            back={() => {
              navigate("/progress/", {
                state: {
                  from_project: project
                },
              });
            }}
          />
        </Box>
      </Container>
    </>
  );
}
